import React, { useState, useEffect } from 'react';
import { Phone, Menu, X, Instagram, Facebook } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo, navLinks } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'py-2' : 'py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <nav
          className={`flex items-center justify-between rounded-full px-6 py-3 transition-all duration-300 ${
            isScrolled
              ? 'bg-brand-dark/95 backdrop-blur-md shadow-lg'
              : 'bg-brand-dark'
          }`}
        >
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#home');
            }}
            className="flex items-center hover:opacity-90 transition-opacity"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_green-solutions-15/artifacts/cw3pso9x_PHOTO-2026-01-26-12-34-00.jpeg" 
              alt="TWINS LAWN & LANDSCAPE LLC"
              className="h-12 md:h-14 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.href)}
                className="text-white/90 hover:text-white hover:bg-white/10 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href={companyInfo.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/90 hover:text-white transition-colors p-2"
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a>
            <a
              href={companyInfo.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/90 hover:text-white transition-colors p-2"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a href={`tel:${companyInfo.phone}`}>
              <Button className="bg-brand-primary text-brand-dark hover:bg-brand-primary/90 rounded-full px-5 py-2 font-semibold flex items-center gap-2 transition-all duration-200 hover:-translate-y-0.5">
                <Phone size={16} />
                {companyInfo.phone}
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-2 bg-brand-dark rounded-3xl p-6 shadow-xl animate-fade-in">
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.href)}
                  className="text-white/90 hover:text-white hover:bg-white/10 px-4 py-3 rounded-xl text-left font-medium transition-all"
                >
                  {link.label}
                </button>
              ))}
              <hr className="border-white/20 my-2" />
              {/* Social Links for Mobile */}
              <div className="flex items-center justify-center gap-4 py-2">
                <a
                  href={companyInfo.facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 hover:bg-brand-primary rounded-full flex items-center justify-center text-white hover:text-brand-dark transition-all duration-300"
                  aria-label="Facebook"
                >
                  <Facebook size={24} />
                </a>
                <a
                  href={companyInfo.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 bg-white/10 hover:bg-brand-primary rounded-full flex items-center justify-center text-white hover:text-brand-dark transition-all duration-300"
                  aria-label="Instagram"
                >
                  <Instagram size={24} />
                </a>
              </div>
              <a
                href={`tel:${companyInfo.phone}`}
                className="flex items-center justify-center gap-2 bg-brand-primary text-brand-dark rounded-full px-5 py-3 font-semibold transition-all"
              >
                <Phone size={18} />
                {companyInfo.phone}
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
